import React from 'react';

import PropTypes from 'prop-types';

import { CustomCheckbox } from 'components/CustomCheckbox/CustomCheckbox';
import { FormSection } from 'components/FormHelper/FormSection';

import './IndeterminateCheckboxRow.sass';

export const IndeterminateCheckboxRow = ({ name, value, indeterminate, label, onChange }) => (
  <div className="checkbox-row indeterminate-checkbox-row">
    <FormSection>
      <div className="label-checkbox">
        <div
          className={`indeterminate-checkbox-row__control${
            indeterminate ? ' indeterminate-checkbox-row__control--indeterminate' : ''
          }`}>
          <CustomCheckbox id={name} name={name} value={value} onChange={() => onChange(!value)} />
          {indeterminate && <span className="indeterminate-checkbox-row__mark">-</span>}
        </div>
        <label htmlFor={name}>{label}</label>
      </div>
    </FormSection>
  </div>
);

IndeterminateCheckboxRow.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

IndeterminateCheckboxRow.defaultProps = {
  indeterminate: false,
};
